
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@src/store';
import { hooksActions } from "../../../../store/reducers/hooksReducer";
import { projectsActions } from "../../../../store/reducers/projectsReducer";
import _ from 'lodash';
import { DialogManagerService } from '@src/services';

// import { DialogManagerService } from '@src/services';

@Component({
    selector: 'hooks',
    template: require('./hooks.component.html'),
    styles: [require('./hooks.component.scss')]
})
export class HooksComponent implements OnDestroy, OnInit {

    public unsubscribe: any;
    public backups: any
    public action: any
    public isAdditionalOptionsCollapsed: boolean
    public modelName: string
    public actionName: string
    public projectId: number
    public additionalOption: any[] = []
    public hooks: any = []
    public events: string[]
    public step: string[]
    public envTypes: string[]
    public IsUserAssign: boolean
    public loginPassword: string
    public loginUser: string
    public timeout: number = 5
    public models: any[]
    public eventSteps: any[]
    public failJobOnFailure: boolean = false


    constructor(private store: Store, @Inject('$stateParams') private $stateParams: any, private dialogManagerService: DialogManagerService) {
        this.projectId = this.$stateParams.id;
        this.IsUserAssign = false;
        this.models = this.store.getState().hooks.hookModels;
        if (this.models.length === 0) {
            this.store.dispatch({ type: hooksActions.GET_HOOKS_MODELS }).then(resp => {
                this.models = resp;
            });
        }

        this.eventSteps = this.store.getState().hooks.hookEventSteps;
        if (_.isEqual(this.eventSteps, {})) {
            this.store.dispatch({ type: hooksActions.GET_HOOKS_EVENTS_AND_STEPS, payload: { projId: this.projectId } }).then(resp => {
                this.eventSteps = resp;
            });
        }

        this.getHooksList();
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }

    modelSelected() {
        this.action = this.store.getState().hooks.hookAction;
        if (this.action.length === 0) {
            this.store.dispatch({ type: hooksActions.GET_ACTION_MODELS, payload: { model: this.modelName } }).then(resp => {
                this.action = resp;
            });
        }
    }

    deleteItem(data) {
        const onConfirm = () => {
            this.store.dispatch({ type: hooksActions.DELETE_HOOK, payload: { hookId: data.id } })
                .then(resp => {
                    if (resp) {
                        const filterdArr = this.hooks.filter(x => x.id !== data.id);
                        this.hooks = filterdArr
                    }
                }
             );;
        }
        const dialogData = { title: 'Delete Backup', action: 'delete', item: 'this hook' };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }

    actionSelected() {
        this.isAdditionalOptionsCollapsed = false;
        this.store.dispatch({
            type: hooksActions.GET_HOOK_PARAMETERS,
            payload: { model: this.modelName, actionName: this.actionName }
        }).then(resp => {

            this.additionalOption.push({
                groupName: 'Hook Options',
                optionsList: new Array()
            });
            resp.map(item => {
                this.additionalOption[0].optionsList.push(item);

            });



        });

    }


    getHooksList() {
        this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectId } }).then(resp => {
            this.hooks = resp.data.hooks;

        });
    }

    inValidHook() {

        if ((this.events && this.events.length > 0) && (this.step && this.step.length > 0)
            && (this.envTypes && this.envTypes.length > 0) && this.modelName && this.actionName && typeof this.timeout === 'number') {
            return this.IsUserAssign && (!this.loginPassword || !this.loginUser);
        }
        return true;
    }

    saveHook() {
        let additionalOption = []
        this.additionalOption[0].groupOptions[0].forEach(element => {
            additionalOption.push(element)
        });

        let hook = {
            id: 0,
            actionName: this.actionName,
            failJobOnFailure: this.failJobOnFailure,
            timeout: this.timeout,
            additionalOption: additionalOption,
            parentId: 0,
            environments: [],
            envTypes: this.envTypes,
            events: this.events,
            loginPassword: this.loginPassword,
            loginUser: this.loginUser,
            modelName: this.modelName,
            step: this.step

        }

        if (!this.IsUserAssign) {
            hook.loginUser = null;
            hook.loginPassword = null;
        }

        this.store.dispatch({
            type: hooksActions.SAVE_HOOK,
            payload: { projId: this.projectId, hookData: hook }
        })
            .then(resp => {
                if (resp) {
                    this.getHooksList()
                }
            });
    }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/hooks-ang7/hooks.component.ts